import { Injectable } from '@angular/core';
import { AuthConfig, AuthProvider } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class AuthConfigService {
  #config: AuthConfig | undefined;

  set config(config: AuthConfig | undefined) {
    this.#config = { ...config, authProvider: config?.authProvider ?? AuthProvider.Legacy };
  }

  get config(): AuthConfig | undefined {
    return this.#config;
  }
}
